const experinces = [
  {
    company: 'Aarhus University',
    title: 'Bachelor of Engineering in Software Technology',
    description:
      'Currently studying as a software engineer at Aarhus University. This degree combines software development expertise with a deep understanding of hardware systems. Graduates are proficient in designing, developing, and maintaining software while also having a strong foundation in hardware technology.   ',
    startDate: 'September 2023',
    endDate: 'February 2027',
    image: '/Assets/Images/aarhus-university.png',
  },
  {
    company: 'Department of Electrical and Computer Engineering',
    title: 'IT-Employee',
    startDate: 'August 2024',
    description:
      'Currently working as an IT Employee at the Department of Electrical and Computer Engineering, Aarhus University. Responsibilities include maintaining and optimizing internal server infrastructure, supporting research equipment, setting up internal networks, assisting with experimental setups, and contributing to the migration of internal servers to Oracle Cloud to enhance scalability, performance, and security.',
    image: '/Assets/Images/ECE.jpg',
  },
  {
    company: 'Schibsted',
    title: 'Student Assistant',
    description:
      "Worked as a Student Assistant in Commercial Listings, where I was responsible for placing Boost-Connect subscribed customers' listings live on the platform DBA by using an RPA tool to create robots.",
    startDate: 'June 2021',
    endDate: 'December 2024',
    image: '/Assets/Images/schibsted.jpg',
  },

  {
    company: 'Danish Technological Institute',
    title: 'Student Assistant',
    description:
      'I have worked as a student assistant in the 3D print department using TypeScript for building a price calculation web application which purpose is to be used internally to simplify work processes in the department.',
    startDate: 'May 2022',
    endDate: 'January 2023',
    image: '/Assets/Images/teknologisk-institut.jpg',
  },

  {
    company: 'Business Academy Aarhus',
    title: 'Computer Science(AP)',
    description:
      "I have studied Computer Science(AP). The education has an emphasis on development and programming of IT systems and we learn about the entire process of software development from needs identification to construction and quality assurance as well as delivery. It's a mixture of programming, system development/design, technology and business-related areas.",
    startDate: 'February 2021',
    endDate: 'June 2023',
    image: '/Assets/Images/baaa.jpg',
  },
];

export default experinces;
